import { createStyles } from '@material-ui/core/styles'
import { tokens } from '../../../assets/tokens'

// Título de página de CommonHeaderGroup (Storybook de Velora). Se mantiene el color de
// texto primario en lugar del de marca: con la opción A el primario es el del cliente
// y no siempre contrasta sobre blanco.
export default () =>
  createStyles({
    root: {
      marginRight: 10,
      flex: 'auto',
      display: 'block',
      '& h1': {
        display: 'block',
        fontFamily: tokens.typography.fontFamily.primary,
        fontSize: 20,
        fontWeight: 600,
        lineHeight: 1.2,
        color: tokens.color.text.primary
      }
    }
  })
